module.exports = __webpack_public_path__ + "static/media/skate-builder-demo.df39dde1.gif";